import React, { useState } from 'react';
import { componentMap } from '../../components/serverDrivenUIComponents/compMapping';
import './ExpandableSquareButtonGroup.scss';

export const ExpandableSquareButtonGroup = ({
  props = {},
  setProductAttribute,
}) => {
  const { square_button_options: options = [] } = props;
  const [expandedButtonIndex, setExpandedButtonIndex] = useState(null);

  if (!Array.isArray(options) || options.length === 0) {
    return null;
  }

  const handleToggle = (index, value) => {
    setExpandedButtonIndex(index === expandedButtonIndex ? null : index);
    setProductAttribute(value);
  };

  return (
    <div className='expandable-square-button-group tw-mt-4'>
      {/* Section A: Buttons */}
      <div className='button-options'>
        {options.map((option, index) => (
          <ExpandableSquareButton
            key={index}
            {...option}
            isExpanded={expandedButtonIndex === index}
            onToggle={() => handleToggle(index, options[index]?.slug)}
          />
        ))}
      </div>

      {/* Section B: Expanded Content */}
      <div className='expanded-content'>
        {expandedButtonIndex !== null &&
          options[expandedButtonIndex]?.children && (
            <div className='expanded-content-container'>
              {options[expandedButtonIndex]?.children.map((child, idx) => (
                <React.Fragment key={idx}>
                  {renderChildComponent(child)}
                </React.Fragment>
              ))}
            </div>
          )}
      </div>
    </div>
  );
};

const ExpandableSquareButton = ({
  slug = 'default-slug',
  title = 'Default Title',
  subtitle = '',
  enabled = true,
  isExpanded,
  onToggle,
  className = '',
  style = {},
}) => {
  return (
    <div
      className={`expandable-square-button ${
        enabled ? '' : 'disabled'
      } ${className}`}
      style={style}
      role='group'
      aria-expanded={isExpanded}
    >
      <div
        className='square-button-header'
        onClick={()=>{
          if (!enabled)return;
          onToggle();
        }}
        aria-controls={`expandable-content-${slug}`}
      >
        <div
          className={`square-button ${enabled ? '' : 'disabled'} ${
            isExpanded ? 'selected' : ''
          }`}
          aria-expanded={isExpanded}
        >
          {/* <span className='button-title-wrapper'></span> */}
          <span className='button-title'>{title}</span>
          {subtitle && <span className='button-subtitle'>{subtitle}</span>}
        </div>
      </div>
    </div>
  );
};

export const renderChildComponent = (child) => {
  if (!child || !child.type) return null;

  const CompName = componentMap[child.type];
  if (!CompName) {
    return null;
  }

  return (
    <div className='child-component-wrapper'>
      <CompName details={child} />
    </div>
  );
};